<template>
  <!-- 顶部 -->
  <header class="gp-header" id="gp-header" style="" v-show="headerIsShow">
    <!-- 左侧 侧边栏 【显示/关闭】 按钮 -->
    <div :class="leftMenuCurrentClass" @click="openLeftMenu()">
      <i></i>
    </div>
    <!-- 左侧 侧边栏 隐藏域-->
    <div :class="leftMenuCurrentState == 0 ? 'nav-controls-menu nav-hide' : 'nav-controls-menu'">
      <div class="menu-container">
        <ul class="nav-menu-links">
          <li>
            <!-- <router-link tag="a" class="nav__link" to="home">HOME</router-link> -->
            <a @click.stop="addRouter_Anchor('home', 'home')" class="nav__link">{{ $t('NavBar.Home') }}</a>
          </li>
          <!-- <li>
            <router-link tag="a" class="nav__link" to="games">GAMES</router-link>
            <a @click.stop="addRouter_Anchor('games')" class="nav__link" >GAMES</a>
          </li> -->
          <li>
            <!-- <router-link tag="a" class="nav__link" to="home">HOME</router-link> -->
            <a @click.stop="addRouter_Anchor('partner', 'home')" class="nav__link">{{ $t('NavBar.Partner') }}</a>
          </li>

          <li>
            <!-- <router-link tag="a" class="nav__link" to="home">HOME</router-link> -->
            <a @click.stop="addRouter_Anchor('games', 'home')" class="nav__link">{{ $t('NavBar.Games') }}</a>
          </li>
          <!-- <li>
            <a @click.stop="addRouter_Anchor('news', 'home')" class="nav__link">{{ $t('NavBar.News') }}</a>
          </li>
          <li>
            <a @click.stop="addRouter_Anchor('weibo', 'home')" class="nav__link">{{ $t('NavBar.Weibo') }}</a>
          </li>
          <li>
            <a @click.stop="addRouter_Anchor('about', 'home')" class="nav__link">{{ $t('NavBar.Aboutus') }}</a>
          </li> -->
          <li class="language">
            <a class="nav__link nav__link--secondary" @click="changeShowLanguage">{{ $t('NavBar.language') }}</a>
            <div class="language-1">
              <a @click="switchLanguage('zh')" class="nav__link">{{ $t('NavBar.zh') }}</a>
              <a @click="switchLanguage('en')" class="nav__link">{{ $t('NavBar.en') }}</a>
            </div>
            <!-- <a v-if="this.$store.state.language == 'chinese'"  @click="switchLanguage('english')"
              class="nav__link">ENGLISH</a>
            <a v-else @click="switchLanguage('chinese')" class="nav__link">中文</a> -->

          </li>

        </ul>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div class="nav-overlay" v-show="leftMenuCurrentState == 1" @click="openLeftMenu()"></div>
    <!-- 顶部 logo 与 登录 -->
    <div class="header-head">
      <!-- 页面缩小到800px以下 显示在头部左侧的注册登录按钮 -->
      <a class="btn__login btn__login--header mobile" v-show="false">
        <a class="button button-text button--transparent ng-scope ng-isolate-scope">
          <div class="button__background"></div>
          <div class="button__slide-in"></div>
          <div class="button__label">
            <span>LOG-IN</span>
          </div>
        </a>
      </a>

      <!-- 页面头部 中央logo -->
      <a href="" class="site__header--logo"></a>

      <!-- 页面缩小到800px以下 显示在头部左侧的注册登录按钮 -->
      <div class="site__header--right desktop" v-show="false">
        <div placeholder="SEARCH" search-url="/search/" class="search-box">
          <input type="text" placeholder="SEARCH" class="search-box__input ng-pristine ng-untouched ng-valid ng-empty"
            id="site__search--query">
          <div class="search-box__button" id="site__search"></div>
          <!-- 搜索框 查询结果列表 -->
          <!-- <div class="search-box__suggested-results ng-hide"></div> -->
        </div>
        <div class="site__header--login-buttons">
          <div class="btns-login-signup ng-scope">
            <a href="">LOG-IN</a>
            <span class="spacer--small"> | </span>
            <a href="">SIGNUP</a>
          </div>
        </div>
        <!-- <div class="locale__list-container animation--fade-in-out ng-hide">
            <ul class="locale__list">
              <li class="locale" ng-attr-id="zz-ZZ" id="zz-ZZ">
                <a href="">
                  <div class="flag flag--dropdown flag--zz-zz"></div>
                  <p>Placeholder</p>
                </a>
              </li>
            </ul>
          </div> -->
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "gp-header",
  data() {
    return {
      // 默认关闭侧边栏    1 显示侧边栏   2  还原状态
      leftMenuCurrentState: 0,
      // 侧边栏 容器 的状态 对应的 classname 
      leftMenuCurrentClass: "left-nav-controls",
      // 按钮的节流锁，上一个操作动画结束前 不能点击，0.8s
      leftMenuDisplayLock: 0,
      debounceTimer: "",
      animate_In: "",
      animate_Out: "",
      headerIsShow: true,
      headerShowActionLock: false,
      currentScrollTopVal: 0,
      scrollTopVal: 0,
      showLanguage: false,
    };
  },
  computed: {
    // navBarArr: function () {
    //   if (this.$store.state.language == "chinese") return this.$store.state.languageCN.navBar;
    //   else return this.$store.state.languageEN.navBar;
    // }
  },
  mounted() {
    //监听鼠标滚动
    window.addEventListener("scroll", this.debounce(this.handleScroll, 100), true);
  },
  beforeDestroy() {
    clearTimeout(this.debounceTimer);
    clearTimeout(this.animate_In);
    clearTimeout(this.animate_Out);
  },
  components: {},
  methods: {
    //切换语言
    changeShowLanguage() {
      this.showLanguage = !this.showLanguage;
    },
    switchLanguage(language) {
      this.$store.dispatch("set_language", language);

      this.$i18n.locale = language

    },
    //0 关闭侧边栏   1 显示侧边栏
    openLeftMenu() {
      if (this.leftMenuDisplayLock == 1) {
        return;
      }
      this.leftMenuDisplayLock = 1;
      //显示
      if (this.leftMenuCurrentState == 0) {
        document.body.classList.add('body-hidden')
        this.leftMenuCurrentClass = "left-nav-controls active";
        this.leftMenuCurrentState = 1;
        setTimeout(() => {
          this.leftMenuDisplayLock = 0;
        }, 800);
      }
      //关闭
      else {
        document.body.classList.remove('body-hidden')
        this.leftMenuCurrentClass = "left-nav-controls active-remove";
        this.leftMenuCurrentState = 0;
        setTimeout(() => {
          this.leftMenuCurrentClass = "left-nav-controls";
          this.leftMenuDisplayLock = 0;
        }, 800);
      }
    },
    addRouter_Anchor(_anchor, _route) {
      console.log("jump");
      event.stopPropagation();

      if (_route) {
        if (_route == "home") {
          this.$router.push({ path: "/" })
        } else {
          this.$router.push(
            {
              path: _route
            }
          )
        }
      }

      this.leftMenuDisplayLock = 1;
      document.body.classList.remove('body-hidden')
      this.leftMenuCurrentClass = "left-nav-controls active-remove";
      this.leftMenuCurrentState = 0;
      setTimeout(() => {
        var anchor = document.querySelector("#anchor-" + _anchor)
        if (anchor) {
          anchor.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
      }, 100);
      setTimeout(() => {

        this.leftMenuCurrentClass = "left-nav-controls";
        this.leftMenuDisplayLock = 0;
      }, 800);
    },
    debounce(fn, wait) {
      this.debounceTimer = null;
      return function () {
        if (this.debounceTimer !== null)
          clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(fn, wait);
      }
    },
    //是否显示顶部header
    handleScroll() {
      this.currentScrollTopVal = this.scrollTopVal;
      this.scrollTopVal = document.body.scrollTop || document.documentElement.scrollTop;
      let _header = document.getElementById("gp-header");

      if (this.currentScrollTopVal < this.scrollTopVal) {
        //下滑
        if (this.headerShowActionLock) {
          return;
        }
        this.headerShowActionLock = true;
        _header.style.animationName = "gp-remove";
        clearTimeout(this.animate_Out);
        clearTimeout(this.animate_In);
        this.animate_Out = setTimeout(() => {
          this.headerIsShow = false;
          this.headerShowActionLock = false;
        }, 800);
      }
      else {
        //上滑
        this.headerIsShow = true;
        _header.style.animationName = "gp-add";
        clearTimeout(this.animate_Out);
        clearTimeout(this.animate_In);
        this.animate_In = setTimeout(() => {
          this.headerShowActionLock = false;
        }, 800);
      }
      // //隐藏header
      // if(Number(scrollTop)>0){
      //   if(this.headerShowActionLock){
      //     return;
      //   }
      //   this.headerShowActionLock = true;
      //   _header.style.animationName="gp-remove";
      //   clearTimeout(this.animate_Out);
      //   clearTimeout(this.animate_In);
      //   this.animate_Out = setTimeout(() => {
      //     this.headerIsShow = false;
      //     this.headerShowActionLock = false;
      //   }, 800);
      // }
      // //显示header
      // else if (Number(scrollTop)==0){
      //   this.headerIsShow = true;
      //   _header.style.animationName="gp-add";
      //   clearTimeout(this.animate_Out);
      //   clearTimeout(this.animate_In);
      //   this.animate_In = setTimeout(() => {
      //     this.headerShowActionLock = false;
      //   }, 800);
      // }
    }
  },
};
</script>

<style lang="scss">
@keyframes gp-add {
  from {
    transform: translateY(-85px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes gp-remove {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(-85px);
    opacity: 0;
  }
}

//侧边栏动画
@keyframes x-to-ham--top-bar {
  0% {
    top: 0;
    transform: rotate(45deg);
    width: 30px;
  }

  50% {
    top: 0;
    transform: none;
  }

  to {
    top: -11px;
    transform: none;
  }
}

@keyframes x-to-ham--element {
  0% {
    background-color: transparent;
  }

  to {
    background-color: #fff;
  }
}

@keyframes x-to-ham--bottom-bar {
  0% {
    top: 0;
    transform: rotate(-45deg);
    width: 30px;
  }

  50% {
    top: 0;
    transform: none;
    width: 30px;
  }

  to {
    top: 11px;
    width: 10.5px;
    transform: none;
  }
}

@keyframes ham-to-x--top-bar {
  0% {
    top: -11px;
  }

  50% {
    top: 0;
    transform: none;
  }

  to {
    top: 0;
    transform: rotate(45deg);
    width: 30px;
  }
}

@keyframes ham-to-x--element {
  0% {
    background-color: #fff;
  }

  to {
    background-color: transparent;
  }
}

@keyframes ham-to-x--bottom-bar {
  0% {
    top: 11px;
  }

  50% {
    top: 0;
    transform: none;
  }

  to {
    top: 0;
    transform: rotate(-45deg);
    width: 30px;
  }
}

.language-1 {
  position: absolute;
  overflow: hidden;
  height: 0;
  transition-duration: 0.5s;
}

.language {
  position: relative;
}

.language:hover .language-1 {
  width: auto;
  height: 150px;
}

// 页面宽度大于1920像素
@media (min-width: 1920px) {
  .nav-controls-menu {
    width: 350px !important;
  }
}

@media (min-width: 801px) {
  .mobile {
    display: none !important;
  }
}

// 页面宽度小于800像素
@media (min-width: 0em) and (max-width:800px) {
  .button {
    min-width: 33% !important;
  }

  .language-1 {
    position: absolute;
    overflow: hidden;
    height: 0;
    left: auto;
    width: 100%;
    right: 0;
    transition-duration: 0.5s;
    text-align: center !important;
  }

  .language:hover .language-1 {
    left: auto;
    width: 100%;
    right: 0;
    height: 150px;
    text-align: center !important;
  }

  .left-nav-controls {
    left: auto !important;
    right: 20px;
    transform: translateZ(1px) rotateY(180deg);
  }

  .nav-controls-menu {
    width: 100vw !important;
    background: rgba(0, 0, 0, .95);
    left: auto;
    right: 0;
    overflow-y: auto;
  }

  .nav-menu-links {
    text-align: center !important;
    padding: 15px 20px !important;
  }

  .menu-container {
    padding-top: 75px !important;
    // padding-bottom: 200px !important;
  }

  .button .button__label {
    padding: .5em 1em !important;
    // padding-top: 11px !important;
    min-width: 0 !important;
  }

  .site__header--logo {
    background-image: url(../assets/home/gamepoch-logo.png) !important;
    background-position: 0 0 !important;
    background-size: 100% auto !important;
    top: 28px !important;
    width: 120px !important;
    height: 60px !important;
  }
}

.gp-header {
  position: fixed;
  z-index: 100;
  width: 100%;
  top: 0;
  left: 0;
  // background: rgba(0,0,0,0.5);
  background: linear-gradient(180deg, rgba(0, 0, 0, .5) 90%, transparent);
  height: 82px;
  animation-duration: 1s;
  display: block;
  // transition: all .5s;
  box-sizing: border-box !important;
}

.left-nav-controls {
  position: absolute;
  z-index: 6;
  top: 28px;
  left: 35px;
  height: 34px;
  width: 25px;
  cursor: pointer;

  i {
    background-color: #fff;
    height: 2px;
    width: 30px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  i:before {
    width: 44px;
    background: #fff;
    height: 2px;
    position: absolute;
    content: "";
    top: -10.5px;
    left: 0;
  }

  i::after {
    background: #fff;
    height: 2px;
    position: absolute;
    content: "";
    width: 11.4px;
    top: 10.5px;
    left: 0;
  }
}

.active {
  i {
    animation-name: ham-to-x--element;
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
  }

  i:before {
    animation-name: ham-to-x--top-bar;
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
  }

  i:after {
    animation-name: ham-to-x--bottom-bar;
    animation-duration: 0.8s;
    animation-fill-mode: forwards;
  }

}

.active-remove {
  i {
    animation-name: x-to-ham--element;
    animation-duration: 0.8s;
  }

  i:before {
    animation-name: x-to-ham--top-bar;
    animation-duration: 0.8s;
  }

  i:after {
    animation-name: x-to-ham--bottom-bar;
    animation-duration: 0.8s;
  }
}

a {
  cursor: pointer;
}

.nav-controls-menu {
  position: fixed;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  width: 230px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  border-right: 1px solid hsla(0, 0%, 100%, 0.1);
  transition: transform 0.8s;

  .menu-container {
    position: relative;
    padding-top: 104px;
    height: calc(100% - 104px);
    transition: all 0.4s linear;
    overflow-y: auto;
  }

  .nav-menu-links {
    margin: 0;
    padding: 15px 15px 15px 80px;
    text-align: left;
    letter-spacing: 1px;
    list-style: none;
  }

  .nav__link {
    transition: color 0.25s linear;
    padding: 0.8em 0;
    display: block;
    color: #fff;
    text-decoration: none;
    font-size: 0.8em;
    font-weight: 600;
  }

  .nav__link:hover {
    color: red;
  }
}

.nav-hide {
  transform: translateX(-101%);
  display: block;
}

.nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 4;
  cursor: default !important;
}


.header-head {
  position: relative;
  z-index: 4;
  width: 100%;
  height: 1px;
  top: 0;
  left: 0;
  overflow: visible;

  .btn__login--header {
    position: absolute;
    top: 28px;
    left: 20px;
    min-width: 70px;
    max-width: 100px;
    // width: 90px;
    // height: 36px;

  }

  .site__header--logo {
    position: absolute;
    display: inline-block;
    transform: translateX(-50%);
    top: 24px;
    left: 50%;
    background-image: url(../assets/home/gamepoch-logo.png);
    background-position: 0 0;
    background-size: 100% auto;
    width: 170px;
    height: 60px;

  }

  .top-nav-gradient.dark .site__header--right {
    top: 50%;
    transform: translateY(-50%)
  }

  .site__header--right {
    position: absolute;
    top: 28px;
    right: 35px;
    min-width: 138px;
    color: #fff;
    font-size: .9em
  }

  @media (min-width: 0em) and (max-width:800px) {
    .site__header--right {
      width: auto
    }
  }

  .search-box {
    display: flex;
  }

  .search-box__input {
    width: calc(100% - 27px);
    position: absolute;
    background-color: transparent;
    height: 22px;
    border-top: thin solid #fff;
    border-right: none;
    border-bottom: thin solid #fff;
    border-left: thin solid #fff;
    color: #fff;
    text-indent: 4px;
    outline: none;
    border-radius: 0;
    padding: 0 !important;
  }

  @media (min-width: 1920px) {
    .search-box__input {
      width: calc(100% - 32px);
      height: 27px;
      // margin-top: 1px;
    }
  }

  .search-box__input:-ms-input-placeholder {
    color: #fff;
    opacity: .5
  }

  .search-box__input::placeholder {
    color: #fff;
    opacity: .5
  }

  .search-box__button {
    background-image: url(../assets/sprite-ui.png);
    background-position: -100px -50px;
    background-size: 302.5px 276.5px;
    width: 27px;
    height: 22px;
    cursor: pointer;
    z-index: 2;
    position: absolute;
    right: 0
  }

  @media (min-width: 1920px) {
    .search-box__button {
      background-image: url(../assets/sprite-lfd.png);
      background-position: -36.5px -159.5px;
      background-size: 251.5px 233.5px;
      width: 34px;
      height: 27px
    }
  }

  .search-box__button:hover {
    background-image: url(../assets/sprite-ui.png);
    background-position: -132px -57px;
    background-size: 302.5px 276.5px;
    width: 27px;
    height: 22px
  }

  @media (min-width: 1920px) {
    .search-box__button:hover {
      background-image: url(../assets/sprite-lfd.png);
      background-position: -75.5px -159.5px;
      background-size: 251.5px 233.5px;
      width: 34px;
      height: 27px
    }
  }

  @media (min-width: 1920px) {
    .search-box__button {
      // bottom:18px
    }
  }

  .site__header--login-buttons {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    width: 100%;
    margin-top: 28px;
    letter-spacing: 1.1px
  }

  @media (min-width: 1920px) {
    .site__header--login-buttons {
      margin-top: 32px
    }
  }

  .btns-login-signup {
    -ms-flex-positive: 1;
    flex-grow: 1;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between
  }

  .btns-login-signup a:hover {
    color: red;
  }

  .btns-login-signup a {
    color: #fff;
    text-decoration: none;
  }

  .spacer--small {
    margin: 0 3px
  }
}

.button.button--transparent .button__label {
  color: #fff;
}

.site__header.site__header--lite .site__header--logo,
.site__header.site__header--lite .site__header--right {
  top: -100px
}</style>


// WEBPACK FOOTER //
// src/components/gp-header.vue